import figure from "../../assets/images/empty-plannings.png";
import './index.scss'

export default function EmptyPlannings({
                                         title = "Você ainda não tem planejamentos",
                                         subtitle = "",
                                         img = null,
                                         children
                                       }) {
  return (
    <div className="empty-plannings">
      <figure>
        <img src={img || figure} alt={title} className="empty-plannings__img"/>
      </figure>
      <div className="empty-plannings__text">
        {
          title && (
            <h3 className="empty-plannings__title">{title}</h3>
          )
        }
        {
          subtitle && (
            <p className="empty-plannings__subtitle">{subtitle}</p>
          )
        }
      </div>
      <div className="empty-plannings__children">
        {children}
      </div>
    </div>
  )
}